// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GeoRegionHook from "../../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CustomerApiHandler from "../state-machine/CustomerApiHandler.bs.js";
import * as CookieUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/CookieUtils.bs.js";
import * as CustomerStateMachine from "../state-machine/CustomerStateMachine.bs.js";
import * as CustomerAssetsManager from "../assets/CustomerAssetsManager.bs.js";
import * as CustomerWalletInfoCmp from "./CustomerWalletInfoCmp.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as CustomerOrderDetailsCmp from "./CustomerOrderDetailsCmp.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as PorterGoldDetailsStateMachine from "../state-machine/PorterGoldDetailsStateMachine.bs.js";

CustomerAssetsManager.importCss(undefined);

function CustomerContainer(Props) {
  var phone_number = Props.phone_number;
  var customer_id = Props.customer_id;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(undefined, undefined, undefined);
  var openSnackbar = match$1[1];
  var match$2 = React.useReducer(CustomerStateMachine.machine, /* Init */0);
  var dispatch = match$2[1];
  var state = match$2[0];
  var fetchCustomerInfo = function (phone_number, customer_id) {
    return CustomerApiHandler.FetchCustomerInfo.execute((function (customer_data, cashback_data) {
                  return Curry._1(dispatch, {
                              TAG: /* FetchCustomerInfoSuccess */0,
                              _0: customer_data,
                              _1: cashback_data
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* FetchCustomerInfoFailed */1,
                              _0: error
                            });
                }), phone_number, customer_id, country);
  };
  var match$3 = React.useReducer(PorterGoldDetailsStateMachine.machine, /* Init */0);
  var porter_gold_details_dispatch = match$3[1];
  var fetchPorterGoldDetails = function (customer_id) {
    return CustomerApiHandler.FetchPorterGoldDetails.execute((function (porter_gold_details) {
                  return Curry._1(porter_gold_details_dispatch, {
                              TAG: /* FetchPorterGoldDetailsSuccess */0,
                              _0: porter_gold_details
                            });
                }), (function (error) {
                  return Curry._1(porter_gold_details_dispatch, {
                              TAG: /* FetchPorterGoldDetailsFailed */1,
                              _0: error
                            });
                }), customer_id, country);
  };
  React.useEffect((function () {
          CookieUtils$Catalyst.setCookie("caller_number=" + phone_number);
          fetchCustomerInfo(phone_number, customer_id);
          
        }), []);
  React.useEffect((function () {
          fetchPorterGoldDetails(customer_id);
          
        }), []);
  var geo_region_items = GeoRegionHook.useGeoRegions(country);
  if (typeof state === "number") {
    return null;
  }
  if (state.TAG !== /* CustomerInfo */0) {
    return null;
  }
  var customer_data = state._0;
  switch (geo_region_items.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement("div", {
                    className: "customer-caller-container"
                  }, React.createElement(CustomerOrderDetailsCmp.make, {
                        openSnackbar: openSnackbar,
                        customer_id: customer_id,
                        customer_data: customer_data,
                        cashback_data: state._1,
                        porter_gold_details_state: match$3[0],
                        dispatch: Curry.__1(dispatch),
                        phone_number: phone_number,
                        geo_region_items: geo_region_items._0
                      }), React.createElement(CustomerWalletInfoCmp.make, {
                        data: customer_data.summary,
                        customer_id: customer_id,
                        openSnackbar: openSnackbar
                      }), match$1[0]);
    case /* Error */2 :
        return null;
    
  }
}

var make = CustomerContainer;

export {
  make ,
  
}
/*  Not a pure module */
